// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--P6krq","label":"_93444fe79c--label--G5hpt"};